// extracted by mini-css-extract-plugin
module.exports = {"color-light":"Paragraph_color-light__JPFRs","noMargin":"Paragraph_noMargin__0SEhc"};